import {Grid} from "@material-ui/core";
import {NumberField, useListContext, useResourceContext} from "react-admin";
import {useQuery} from "react-query";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import {useListQueryParams} from "../shared/hooks/useListQueryParams";
import {client, getRealResource} from "../dataProvider";
import {StatCard} from "../components/StatCard";
import {useEffect, useState} from "react";


export const InvoiceListHeader = () => {
    const resource = useResourceContext();
    const query = useListQueryParams();
    const {filterValues, filter, ids, data, selectedIds} = useListContext();
    const url = `${getRealResource(resource)}/statistics`;
    const [selectedStats, setSelectedStats] = useState(
        {
            id: 0,
            tot_amount: 0,
            tot_taxable: 0,
        }
    )

    useEffect(() => {
        if (selectedIds && data) {
            let tempsManualStats = {
                id: 0,
                tot_amount: 0,
                tot_taxable: 0,
            };
            for (let sId of selectedIds) {
                const row = data[sId];

                const docSign = row.type === "FT" ? 1 : -1;
                tempsManualStats.tot_amount += row.amount * docSign;
                tempsManualStats.tot_taxable += row.taxable * docSign;
            }

            setSelectedStats(tempsManualStats);
        }
    }, [selectedIds, data]);

    const {data: stats} = useQuery(
        [url, query, filterValues, filter, ids],
        () =>
            client(url, {
                method: "GET",
                params: {
                    ...query,
                    ...filter,
                    ...filterValues,
                },
                paramsSerializer: function handleQuery(q: any) {
                    return Object.entries(q).map(([key, value], i) => Array.isArray(value) ? `${key}=${value.join('&' + key + '=')}` : `${key}=${value}`).join('&');
                }
            }),
        {
            initialData: {
                total_amount: 0
            },
        }
    );
    return (
        <Grid container>
            <Grid item xs={12} sm={6}>
                <StatCard
                    label={
                        <NumberField
                            record={stats}
                            source="taxable__sum"
                            variant="inherit"
                            options={{
                                style: "currency",
                                currency: "EUR",
                            }}
                        />
                    }
                    icon={<AttachMoneyIcon/>}
                    subtitle="Totale imponibile"
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <StatCard
                    label={
                        <NumberField
                            record={stats}
                            source="amount__sum"
                            variant="inherit"
                            options={{
                                style: "currency",
                                currency: "EUR",
                            }}
                        />
                    }
                    icon={<AttachMoneyIcon/>}
                    subtitle="Totale importo"
                />
            </Grid>


            {
                selectedStats && (
                    <>
                        <Grid item xs={12} sm={6}>
                            <StatCard
                                label={
                                    <NumberField
                                        record={selectedStats}
                                        source="tot_taxable"
                                        variant="inherit"
                                        options={{
                                            style: "currency",
                                            currency: "EUR",
                                        }}
                                    />
                                }
                                icon={<AttachMoneyIcon/>}
                                subtitle="Totale imponibile selezionato"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <StatCard
                                label={
                                    <NumberField
                                        record={selectedStats}
                                        source="tot_amount"
                                        variant="inherit"
                                        options={{
                                            style: "currency",
                                            currency: "EUR",
                                        }}
                                    />
                                }
                                icon={<AttachMoneyIcon/>}
                                subtitle="Totale importo selezionato"
                            />
                        </Grid>
                    </>
                )
            }


        </Grid>
    );
};
